import { Loader } from '@googlemaps/js-api-loader'

export const loader = new Loader({
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY,
  version: 'weekly',
  language: 'de',
  libraries: ['places'],
})
